import Tag from '@/views/tag'
import AddChkItem from '@/views/tag/add-checklist-item'
import List from '@/views/tag/list'

export default {
  path: 'tags',
  component: Tag,
  redirect: 'tags/list',
  name: 'Tags',
  children: [
    {
      path: 'list',
      name: 'user.list',
      component: List
    },
    {
      path: 'checklist-items',
      name: 'Checklist Item',
      component: AddChkItem
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/hashtag/hashtag.js